import { useDecision } from '@optimizely/react-sdk';

import {
  getDecideOptions,
  transformDecision,
  type FeatureFlagResult,
  type FlagOptions,
} from './featureFlagDecision';
import { type FeatureFlag } from './featureFlags';

export const useFeatureFlag = <T extends FeatureFlag>(
  featureFlag: T,
  options?: FlagOptions,
): FeatureFlagResult<T> | null => {
  const [decision, clientReady] = useDecision(featureFlag.name, {
    autoUpdate: true,
    decideOptions: getDecideOptions(options),
  });

  if (!clientReady) return null;

  return transformDecision(featureFlag, decision);
};
